[
  {
    "id": "0",
    "title": {
      "fr": "Les constellations",
      "en": "Constellations",
      "es": "Las constelaciones"
    },
    "description": {
      "fr": "Igor peut maintenant poser 2 bombes au lieu d'une seule à la fois, et ce, de manière permanente !",
      "en": "From now on and forever, Igor can place 2 bombs!",
      "es": "A partir de ahora y para siempre, ¡Igor puede poner 2 bombas!"
    },
    "require": [
      {
        "id": "40",
        "qty": 1
      },
      {
        "id": "41",
        "qty": 1
      },
      {
        "id": "42",
        "qty": 1
      },
      {
        "id": "43",
        "qty": 1
      },
      {
        "id": "44",
        "qty": 1
      },
      {
        "id": "45",
        "qty": 1
      },
      {
        "id": "46",
        "qty": 1
      },
      {
        "id": "47",
        "qty": 1
      },
      {
        "id": "48",
        "qty": 1
      },
      {
        "id": "49",
        "qty": 1
      },
      {
        "id": "50",
        "qty": 1
      },
      {
        "id": "51",
        "qty": 1
      }
    ]
  },
  {
    "id": "1",
    "title": {
      "fr": "Mixtures du zodiaque",
      "en": "Zodiac mixture",
      "es": "Influencias del zodíaco"
    },
    "description": {
      "fr": "Igor sait désormais envoyer ses bombes à l'étage supérieur ! Maintenez BAS enfoncé pendant que vous tapez dans une bombe posée.",
      "en": "Igor knows how to place his bombs vertically now and he can place them on the upper platform! Press DOWN arrow key beside a placed bomb.",
      "es": "Igor ya sabe lanzar verticalmente sus bombas y colocarlas en la plataforma superior. Pulsa ABAJO junto a una bomba ya lanzada."
    },
    "require": [
      {
        "id": "52",
        "qty": 1
      },
      {
        "id": "53",
        "qty": 1
      },
      {
        "id": "54",
        "qty": 1
      },
      {
        "id": "55",
        "qty": 1
      },
      {
        "id": "56",
        "qty": 1
      },
      {
        "id": "57",
        "qty": 1
      },
      {
        "id": "58",
        "qty": 1
      },
      {
        "id": "59",
        "qty": 1
      },
      {
        "id": "60",
        "qty": 1
      },
      {
        "id": "61",
        "qty": 1
      },
      {
        "id": "62",
        "qty": 1
      },
      {
        "id": "63",
        "qty": 1
      }
    ]
  },
  {
    "id": "2",
    "title": {
      "fr": "Premiers pas",
      "en": "First steps",
      "es": "Primeros pasos"
    },
    "description": {
      "fr": "Igor débutera désormais la partie avec une vie supplémentaire.",
      "en": "From now on Igor will always start the game with an extra life.",
      "es": "A partir de ahora Igor empezará siempre la partida con una vida extra."
    },
    "require": [
      {
        "id": "103",
        "qty": 1
      }
    ]
  },
  {
    "id": "3",
    "title": {
      "fr": "L'aventure commence",
      "en": "The adventure begins",
      "es": "La aventura comienza"
    },
    "description": {
      "fr": "Igor débutera désormais la partie avec une autre vie supplémentaire.",
      "en": "Igor will start from now on the game with another extra life.",
      "es": "Igor empezará para siempre la partida con otra vida extra."
    },
    "require": [
      {
        "id": "104",
        "qty": 1
      }
    ]
  },
  {
    "id": "4",
    "title": {
      "fr": "Une destinée épique",
      "en": "An epic fate",
      "es": "Un destino épico"
    },
    "description": {
      "fr": "Igor débutera désormais la partie avec encore une vie supplémentaire !",
      "en": "Igor will start the game with another life!",
      "es": "¡Igor empezará la partida con otra vida extra más!"
    },
    "require": [
      {
        "id": "105",
        "qty": 1
      }
    ]
  },
  {
    "id": "5",
    "title": {
      "fr": "Persévérance",
      "en": "Perseverance",
      "es": "Perseverancia"
    },
    "description": {
      "fr": "Igor débutera désormais la partie avec une vie supplémentaire.",
      "en": "Igor will start the game with an extra life.",
      "es": "Igor empezará la partida con una vida extra."
    },
    "require": [
      {
        "id": "36",
        "qty": 5
      }
    ]
  },
  {
    "id": "6",
    "title": {
      "fr": "Gourmandise",
      "en": "Delicacies",
      "es": "Gourmand"
    },
    "description": {
      "fr": "De nouveaux aliments (plus sains) apparaîtront désormais en jeu !",
      "en": "New food, healthier and nicer, will appear now in the game.",
      "es": "Nuevos alimentos, más sanos y apetitosos, aparecerán ahora en el juego."
    },
    "require": [
      {
        "id": "1000",
        "qty": 5
      },
      {
        "id": "1003",
        "qty": 1
      },
      {
        "id": "1013",
        "qty": 1
      },
      {
        "id": "1027",
        "qty": 1
      },
      {
        "id": "1041",
        "qty": 1
      },
      {
        "id": "1043",
        "qty": 1
      }
    ]
  },
  {
    "id": "7",
    "title": {
      "fr": "Du sucre !",
      "en": "Some sugar!",
      "es": "¡Quiero algo dulce!"
    },
    "description": {
      "fr": "Igor veut encore plus de sucre ! Des délicieuses friandises apparaîtront désormais en jeu.",
      "en": "Igor wants more sweet things! From now on sweets will appear in the game.",
      "es": "¡Igor quiere azúcar! A partir de ahora aparecerán chucherías en el juego."
    },
    "require": [
      {
        "id": "1003",
        "qty": 10
      },
      {
        "id": "1027",
        "qty": 10
      },
      {
        "id": "1041",
        "qty": 10
      },
      {
        "id": "1070",
        "qty": 2
      },
      {
        "id": "1074",
        "qty": 2
      }
    ]
  },
  {
    "id": "8",
    "title": {
      "fr": "Malnutrition",
      "en": "Malnutrition",
      "es": "Malnutrición"
    },
    "description": {
      "fr": "Le goût d'Igor pour les aliments peu équilibrés lui permettra de trouver des aliments encore plus... \"douteux\" en jeu.",
      "en": "Igor's taste for badly-balanced food will lead him to find even more food of questionable quality.",
      "es": "El gusto de Igor por los alimentos poco equilibrados le permitirá encontrar aún más alimentos de dudosa capacidad nutritiva."
    },
    "require": [
      {
        "id": "1022",
        "qty": 5
      },
      {
        "id": "1024",
        "qty": 5
      },
      {
        "id": "1028",
        "qty": 20
      },
      {
        "id": "1025",
        "qty": 10
      }
    ]
  },
  {
    "id": "9",
    "title": {
      "fr": "Goût raffiné",
      "en": "Good taste",
      "es": "Gusto refinado"
    },
    "description": {
      "fr": "Le régime bizarre d'Igor a amené de nouveaux aliments exotiques en jeu !",
      "en": "Igor's weird diet brings exotic new food to the game!",
      "es": "¡El régimen extraño de Igor trae nuevos y exóticos alimentos en el juego!"
    },
    "require": [
      {
        "id": "1002",
        "qty": 1
      },
      {
        "id": "1046",
        "qty": 2
      },
      {
        "id": "1040",
        "qty": 10
      }
    ]
  },
  {
    "id": "10",
    "title": {
      "fr": "Avancée technologique",
      "en": "Technological advance",
      "es": "Avance tecnológico"
    },
    "description": {
      "fr": "Pour vous aider dans votre aventure, tout un tas d'objets aux effets bizarres font leur apparition en jeu !",
      "en": "A lot of items of weird effects appear now in the game to help you in the adventure!",
      "es": "¡Un montón de objetos con efectos raros aparecen ahora en el juego para ayudarte en tu aventura!"
    },
    "require": [
      {
        "id": "4",
        "qty": 1
      },
      {
        "id": "7",
        "qty": 1
      },
      {
        "id": "13",
        "qty": 1
      }
    ]
  },
  {
    "id": "11",
    "title": {
      "fr": "Le petit guide des Champignons",
      "en": "Small guide to mushrooms",
      "es": "La pequeña guía de hongos"
    },
    "description": {
      "fr": "Igor a découvert un étrange ouvrage, une sorte de livre de cuisine traitant des champignons hallucinogènes. Il pourra désormais en trouver lors de ses explorations.",
      "en": "Igor has discovered a rare text. It's a kind of cookbook about hallucinogenic mushrooms. Igor will be able to find them now.",
      "es": "Igor ha descubierto una obra extraña. Es una especie de libro de cocina sobre hongos alucinógenos. Ahora podrá encontrarlos en sus búsquedas."
    },
    "require": [
      {
        "id": "106",
        "qty": 1
      }
    ]
  },
  {
    "id": "12",
    "title": {
      "fr": "Trouver les pièces d'or secrètes !",
      "en": "Find the secret golden coins!",
      "es": "¡Encuentra las monedas de oro secretas!"
    },
    "description": {
      "fr": "Des richesses supplémentaires de très grande valeur apparaitront maintenant en jeu !",
      "en": "Great new richness will appear now in the game!",
      "es": "¡Nuevas riquezas de gran valor aparecerán ahora en el juego!"
    },
    "require": [
      {
        "id": "1051",
        "qty": 150
      }
    ]
  },
  {
    "id": "13",
    "title": {
      "fr": "Le grimoire des Etoiles",
      "en": "The book of Magic Stars",
      "es": "El grimorio de las Estrellas"
    },
    "description": {
      "fr": "Cet ouvrage mystérieux en dit long sur les 12 constellations du Zodiaque. Vous pourrez désormais les collectionner en jeu !",
      "en": "This mysterious in-depth book talks about the 12 Zodiac Constellations. They are now available in the game!",
      "es": "Esta obra misteriosa habla extensamente sobre las 12 constelaciones del Zodíaco. ¡Ya están disponibles en el juego!"
    },
    "require": [
      {
        "id": "107",
        "qty": 1
      }
    ]
  },
  {
    "id": "14",
    "title": {
      "fr": "Armageddon",
      "en": "Armageddon",
      "es": "Armageddon"
    },
    "description": {
      "fr": "Des objets aux effets ravageurs vont maintenant apparaître en jeu !",
      "en": "Items with devastating powers will appear now in the game!",
      "es": "¡Objetos con efectos devastadores aparecerán ahora en el juego!"
    },
    "require": [
      {
        "id": "1",
        "qty": 10
      },
      {
        "id": "5",
        "qty": 5
      },
      {
        "id": "11",
        "qty": 5
      },
      {
        "id": "21",
        "qty": 10
      },
      {
        "id": "22",
        "qty": 5
      },
      {
        "id": "24",
        "qty": 1
      },
      {
        "id": "25",
        "qty": 1
      },
      {
        "id": "28",
        "qty": 3
      },
      {
        "id": "38",
        "qty": 1
      },
      {
        "id": "82",
        "qty": 5
      }
    ]
  },
  {
    "id": "15",
    "title": {
      "fr": "Régime MotionTwin",
      "en": "MotionTwin Diet",
      "es": "Régimen MotionTwin"
    },
    "description": {
      "fr": "A force de manger n'importe quoi, Igor a acquis la maîtrise des jeux ! Il pourra collectionner des objets rarissimes pendant son exploration et trouver\tdes aliments d'exception !",
      "en": "After eating every kind of food, no matter what, Igor has become a Master of the games! Now he will be able to collect rare items and exceptional food during his adventure!",
      "es": "A base de comer cualquier cosa, ¡Igor se ha vuelto un maestro de los juegos! Ahora podrá coleccionar objetos y alimentos muy raros durante su aventura."
    },
    "require": [
      {
        "id": "1057",
        "qty": 11
      },
      {
        "id": "1074",
        "qty": 11
      },
      {
        "id": "1137",
        "qty": 11
      },
      {
        "id": "1138",
        "qty": 11
      },
      {
        "id": "1139",
        "qty": 11
      },
      {
        "id": "1140",
        "qty": 11
      },
      {
        "id": "1149",
        "qty": 20
      },
      {
        "id": "1045",
        "qty": 30
      },
      {
        "id": "1081",
        "qty": 11
      }
    ]
  },
  {
    "id": "16",
    "title": {
      "fr": "Créateur de jeu en devenir",
      "en": "Creator of games",
      "es": "Creador de juegos innovadores"
    },
    "description": {
      "fr": "Igor semble apprécier les aliments basiques, une belle carrière dans le monde du jeu vidéo pourrait s'offrir à lui ! Des aliments adaptés lui seront dorénavant proposés et quelques cartes à jouer pour se faire la main.",
      "en": "Igor appreciates basic food. He could be offered a nice career in videogames! Adapted food will be available in the game, and also a deck of cards!",
      "es": "Igor aprecia los alimentos básicos, así que puede que se le presente una bella carrera en el mundo de los videojuegos. Alimentos adaptados a él le serán a partir de ahora propuestos durante el juego, ¡así como una baraja de cartas!"
    },
    "require": [
      {
        "id": "1142",
        "qty": 20
      }
    ]
  },
  {
    "id": "17",
    "title": {
      "fr": "La vie est une boîte de chocolats",
      "en": "Life is like a box of chocolates...",
      "es": "La vida es como una caja de bombones..."
    },
    "description": {
      "fr": "De délicieux chocolats sont maintenant distribués en Hammerfest !",
      "en": "Delicious chocolates will be now available in Hammerfest!",
      "es": "¡Deliciosos bombones tan sorprendentes como la vida misma son distribuidos ahora en Hammerfest!"
    },
    "require": [
      {
        "id": "1046",
        "qty": 5
      }
    ]
  },
  {
    "id": "18",
    "title": {
      "fr": "Le trésor Oune-difaïned",
      "en": "Difaïned treasure",
      "es": "El tesoro difaïned"
    },
    "description": {
      "fr": "A force de ramasser des diamants apparus on ne sait comment, Igor a acquis la faculté de repérer des pierres précieuses rares ! Il en trouvera au cours de ses explorations.",
      "en": "After collecting so many diamonds of mysterious origin, Igor adquires the ability of finding precious stones! He'll be able now to find them throughout his quests.",
      "es": "A base de recoger tantos diamantes de misteriosa aparición, ¡Igor ha adquirido la facultad de localizar las piedras preciosas raras! Ahora podrá encontrarlas a lo largo de sus exploraciones."
    },
    "require": [
      {
        "id": "1008",
        "qty": 30
      }
    ]
  },
  {
    "id": "19",
    "title": {
      "fr": "Super size me !",
      "en": "Super size me!",
      "es": "Super size me!"
    },
    "description": {
      "fr": "Toujours plus loin dans la malnutrition, Igor a découvert qu'il pouvait aussi se nourrir de produits en boite.",
      "en": "Keeping far from good food, Igor discovers now that he can also eat canned food!",
      "es": "Como siempre, bien lejos de la buena alimentación, Igor descubre que puede también alimentarse de alimentos en conserva."
    },
    "require": [
      {
        "id": "1001",
        "qty": 20
      },
      {
        "id": "1055",
        "qty": 20
      },
      {
        "id": "1056",
        "qty": 20
      }
    ]
  },
  {
    "id": "20",
    "title": {
      "fr": "Maître joaillier",
      "en": "Master jeweller",
      "es": "Maestro joyero"
    },
    "description": {
      "fr": "Igor est devenu un véritable expert en pierres précieuses. Il pourra maintenant découvrir de puissants bijoux magiques au fil de ses explorations !",
      "en": "Igor has become an expert in precious stones. Now his knowledge permits him to discover precious stones which are even more powerful!",
      "es": "Igor se ha convertido en un auténtico experto en piedras preciosas. ¡Ahora sus conocimientos le permiten descubrir joyas preciosas aún más poderosas!"
    },
    "require": [
      {
        "id": "1009",
        "qty": 10
      },
      {
        "id": "1010",
        "qty": 5
      },
      {
        "id": "1011",
        "qty": 1
      }
    ]
  },
  {
    "id": "21",
    "title": {
      "fr": "Grand prédateur",
      "en": "Great Predator",
      "es": "Gran Depredador"
    },
    "description": {
      "fr": "Igor en a plus qu'assez de chasser des choses sucrées ! Désormais devenu un prédateur sans pitié, il pourra traquer et dévorer toute sorte de charcuteries.",
      "en": "Igor is fed up hunting sweets! As he has turned into an unconditional predator, now he will be able to devour any sort of delicacy.",
      "es": "¡Igor está bien harto cazar chucherías! Depredador incondicional, ahora podrá devorar toda clase de charcutería."
    },
    "require": [
      {
        "id": "1001",
        "qty": 20
      },
      {
        "id": "1021",
        "qty": 10
      },
      {
        "id": "1025",
        "qty": 20
      },
      {
        "id": "1061",
        "qty": 1
      },
      {
        "id": "1162",
        "qty": 10
      }
    ]
  },
  {
    "id": "22",
    "title": {
      "fr": "Expert en salades et potages",
      "en": "Expert in salads and stews",
      "es": "Experto en ensaladas y potajes"
    },
    "description": {
      "fr": "On raconte partout qu'Igor serait la réincarnation de Saladou, le maître mondialement reconnu de la salade. Fort de ce don, il pourra à l'avenir cueillir une très grande variété de légumes !",
      "en": "They say that Igor is the reencarnation of Saladou, the world famous master of salads for virtual rabbits. With this new talent, he will be able to collect a great variety of vegetables!",
      "es": "Se cuenta que Igor es la reencarnación de Ensalado, el reconocido maestro de la ensalada para conejos virtuales. ¡Con su don podrá recoger una gran variedad de verduras!"
    },
    "require": [
      {
        "id": "1020",
        "qty": 15
      },
      {
        "id": "1039",
        "qty": 1
      },
      {
        "id": "1060",
        "qty": 2
      },
      {
        "id": "1104",
        "qty": 5
      },
      {
        "id": "1103",
        "qty": 3
      }
    ]
  },
  {
    "id": "23",
    "title": {
      "fr": "Festin d'Hammerfest",
      "en": "Hammerfest Feast",
      "es": "Festín de Hammerfest"
    },
    "description": {
      "fr": "Avec un repas aussi complet, Igor est fin prêt pour avoir accès aux patisseries les plus raffinées qui existent.",
      "en": "After a complete lunch, Igor will now have access to really delicious cakes.",
      "es": "Tras una comida tan completa, Igor está al fin listo para acceder a pasteles de exquisito gusto."
    },
    "require": [
      {
        "id": "1091",
        "qty": 1
      },
      {
        "id": "1112",
        "qty": 1
      },
      {
        "id": "1126",
        "qty": 1
      },
      {
        "id": "1163",
        "qty": 1
      },
      {
        "id": "1109",
        "qty": 1
      },
      {
        "id": "1138",
        "qty": 1
      },
      {
        "id": "1142",
        "qty": 1
      }
    ]
  },
  {
    "id": "24",
    "title": {
      "fr": "Goûter d'anniversaire",
      "en": "Birthday party",
      "es": "Merienda de cumpleaños"
    },
    "description": {
      "fr": "Igor a trouvé tous les éléments pour assurer à son prochain goûter d'anniversaire ! Il trouvera maintenant pleins de petits en-cas pour patienter jusque là.",
      "en": "Igor has found all the required elements for his next birthday party! From now on he will get even more until that time comes.",
      "es": "¡Igor ha encontrado todos los elementos para asegurar una buena merienda de cumpleaños! A partir de ahora podrá obtener aún más dulces para una segunda merienda."
    },
    "require": [
      {
        "id": "68",
        "qty": 1
      },
      {
        "id": "1004",
        "qty": 10
      },
      {
        "id": "1005",
        "qty": 10
      },
      {
        "id": "1007",
        "qty": 1
      },
      {
        "id": "1015",
        "qty": 1
      },
      {
        "id": "1016",
        "qty": 3
      },
      {
        "id": "1018",
        "qty": 5
      },
      {
        "id": "1019",
        "qty": 5
      },
      {
        "id": "1023",
        "qty": 10
      },
      {
        "id": "1070",
        "qty": 10
      }
    ]
  },
  {
    "id": "25",
    "title": {
      "fr": "Bon vivant",
      "en": "Bon vivant",
      "es": "Vividor"
    },
    "description": {
      "fr": "Un bon repas ne peu se concevoir sans des petits trucs à grignotter à l'apéritif. Igor le sait, maintenant, et il pourra trouver ce qu'il faut en jeu.",
      "en": "We can't imagin a good lunch without a nice aperitive. Igor knows now what he needs.",
      "es": "Una buena comida no puede ser concebida sin tomarse antes unas tapas. Ahora Igor conoce bien lo que se necesita para un buen tapeo."
    },
    "require": [
      {
        "id": "1069",
        "qty": 10
      },
      {
        "id": "1081",
        "qty": 10
      },
      {
        "id": "1094",
        "qty": 10
      }
    ]
  },
  {
    "id": "26",
    "title": {
      "fr": "Fondue norvégienne",
      "en": "Norwegian fondue",
      "es": "Fondue noruega"
    },
    "description": {
      "fr": "Les odeurs qui émanent de la tanière d'Igor ne laissent aucun doute là-dessus: il est devenu un grand amateur de fromages. De nouveaux produits laitiers apparaîtront dans les cavernes.",
      "en": "The smells that come from Igor's lair don't leave a doubt about it: he has become a great lover of cheese. New dairy products will appear now in the caverns.",
      "es": "Los olores que emanan de la guarida de Igor no dejan ninguna duda: ha caído en el lado pestoso de los quesos. Ahora aparecerán nuevos productos lácteos en las cavernas."
    },
    "require": [
      {
        "id": "1031",
        "qty": 10
      },
      {
        "id": "1057",
        "qty": 10
      },
      {
        "id": "1137",
        "qty": 1
      }
    ]
  },
  {
    "id": "27",
    "title": {
      "fr": "Mystère de Guu",
      "en": "Guu's mistery",
      "es": "Misterio de Guu"
    },
    "description": {
      "fr": "Cette quête n'a aucun intérêt, à part vous conseiller de découvrir au plus vite l'excellent dessin animé \"Haré + Guu\" disponible en DVD dans toutes les bonnes boutiques ! Banyaaaaaïï. ^^",
      "en": "This quest hasn't any practical use. It's only to suggest to you the great anime \"Jungle wa itsumo Hare nochi Guu\". Banyaaaaaïï ^__^",
      "es": "Esta exploración no tiene ningún interés, sólo el de aconsejarte el genial anime \"Jungle wa itsumo Hare nochi Guu\". Banyaaaaaïï ^__^"
    },
    "require": [
      {
        "id": "88",
        "qty": 1
      },
      {
        "id": "99",
        "qty": 1
      },
      {
        "id": "100",
        "qty": 1
      },
      {
        "id": "1044",
        "qty": 1
      }
    ]
  },
  {
    "id": "28",
    "title": {
      "fr": "Friandises divines",
      "en": "Divine sweets",
      "es": "Chucherías divinas"
    },
    "description": {
      "fr": "Les sucreries n'ont plus aucun secret pour Igor. Il saura, à compter de ce jour, débusquer les délices légendaires de Harry \"le beau\" disséminés à travers tout Hammerfest.",
      "en": "Sweets are no longer a secret to Igor. Now he will be able to collect any of Good-looking Harry's legendary sweets that he finds in Hammerfest!",
      "es": "Las golosinas ya no son ningún secreto para Igor. ¡Ahora podrá arrasar con cualquier chuchería legendaria de Harry \"el guapo\" que se le presente!"
    },
    "require": [
      {
        "id": "1059",
        "qty": 2
      },
      {
        "id": "1084",
        "qty": 2
      },
      {
        "id": "1088",
        "qty": 2
      },
      {
        "id": "1144",
        "qty": 2
      },
      {
        "id": "1151",
        "qty": 2
      },
      {
        "id": "1152",
        "qty": 2
      },
      {
        "id": "1153",
        "qty": 2
      },
      {
        "id": "1154",
        "qty": 2
      }
    ]
  },
  {
    "id": "29",
    "title": {
      "fr": "Igor et Cortex",
      "en": "Igor and Cortex",
      "es": "Igor y Cortex"
    },
    "description": {
      "fr": "Igor a entrepris la fabrication de gadgets mystérieux... Attendez-vous à collectionner des machines étranges en jeu !",
      "en": "Igor has started to make mysterious gadgets... get ready to collect strange machines in the game!",
      "es": "Igor se ha puesto a fabricar cachibaches misteriosos... ¡prepárate para coleccionar máquinas extrañas en el juego!"
    },
    "require": [
      {
        "id": "21",
        "qty": 10
      },
      {
        "id": "26",
        "qty": 10
      },
      {
        "id": "31",
        "qty": 10
      },
      {
        "id": "85",
        "qty": 10
      },
      {
        "id": "90",
        "qty": 10
      }
    ]
  },
  {
    "id": "30",
    "title": {
      "fr": "Affronter l'obscurité",
      "en": "Facing the darkness",
      "es": "Afrontar la oscuridad"
    },
    "description": {
      "fr": "Igor sait maintenant s'éclairer ! Il pensera maintenant à apporter avec lui une torche pour ne pas trop se perdre dans l'obscurité des niveaux avancés !",
      "en": "Igor has learnt to light himself up! Thanks to this torch he won't get lost any more in the darkness of the advanced levels!",
      "es": "¡Igor ha aprendido a autoiluminarse! ¡Gracias a su antorcha incorporada ya no se perderá en la oscuridad de los niveles más avanzados!"
    },
    "require": [
      {
        "id": "68",
        "qty": 10
      }
    ]
  },
  {
    "id": "31",
    "title": {
      "fr": "Et la lumière fût !",
      "en": "And light appeared!",
      "es": "¡Y se hizo la luz!"
    },
    "description": {
      "fr": "Préparé à tous les dangers, le courageux Igor ne craint plus du tout l'obscurité dans les niveaux avancés !",
      "en": "Ready for every danger, Igor won't ever be afraid of the darkness of the advanced levels!",
      "es": "Preparado para los peligros de la vida moderna, ¡Igor no temerá nunca más a la oscuridad de los niveles avanzados!"
    },
    "require": [
      {
        "id": "26",
        "qty": 10
      }
    ]
  },
  {
    "id": "32",
    "title": {
      "fr": "Noël sur Hammerfest !",
      "en": "Christmas in Hammerfest!",
      "es": "¡Navidad en Hammerfest!"
    },
    "description": {
      "fr": "Vous avez gagné 5 parties supplémentaires.",
      "en": "You won 5 extra lives!!",
      "es": "¡¡Has ganado 5 vidas extra!!"
    },
    "require": [
      {
        "id": "109",
        "qty": 1
      }
    ]
  },
  {
    "id": "33",
    "title": {
      "fr": "Joyeux anniversaire Igor",
      "en": "Happy birthday Igor",
      "es": "Feliz cumpleaños Igor"
    },
    "description": {
      "fr": "Vous avez gagné 10 parties supplémentaires !",
      "en": "You won 10 free games!!",
      "es": "¡¡Has ganado 10 partidas gratis!!"
    },
    "require": [
      {
        "id": "110",
        "qty": 2
      }
    ]
  },
  {
    "id": "34",
    "title": {
      "fr": "Cadeau céleste",
      "en": "Celestial present",
      "es": "Regalo celestial"
    },
    "description": {
      "fr": "Vous avez gagné 20 parties supplémentaires !",
      "en": "You won 20 free games!!",
      "es": "¡¡Has ganado 20 partidas gratis!!"
    },
    "require": [
      {
        "id": "111",
        "qty": 2
      }
    ]
  },
  {
    "id": "35",
    "title": {
      "fr": "Achat de parties amélioré",
      "en": "Game purchase enhanced",
      "es": "Compra de partidas mejorada"
    },
    "description": {
      "fr": "Vos appels dans la boutique vous rapporteront dorénavant plus de flocons !",
      "en": "From now on, each time you buy games with our payment service, you'll obtain more games for the same price!",
      "es": "A partir de ahora cada vez que compres partidas con nuestro sistema de pago, ¡obtendrás más partidas que antes por el mismo precio!"
    },
    "require": [
      {
        "id": "10",
        "qty": 5
      }
    ]
  },
  {
    "id": "36",
    "title": {
      "fr": "Exterminateur de Sorbex",
      "en": "Sorbex exterminator",
      "es": "Exterminador de Sorbetex"
    },
    "description": {
      "fr": "Vous avez pressé sans pitié les Citrons Sorbex !",
      "en": "You squeezed the Sorbex lemons without mercy!",
      "es": "¡Has presionado sin piedad a los limones Sorbetex!"
    },
    "require": [
      {
        "id": "1178",
        "qty": 1
      }
    ]
  },
  {
    "id": "37",
    "title": {
      "fr": "Désamorceur de Bombinos",
      "en": "Bombino disposal expert",
      "es": "Desactivador de Bombinos"
    },
    "description": {
      "fr": "Vous avez survécu aux explosions des Bombinos !",
      "en": "You survived the Bombinos explosions!",
      "es": "¡Has sobrevivido a las explosiones de los Bombinos!"
    },
    "require": [
      {
        "id": "1179",
        "qty": 1
      }
    ]
  },
  {
    "id": "38",
    "title": {
      "fr": "Tueur de poires",
      "en": "Pear killer",
      "es": "Asesino de peras"
    },
    "description": {
      "fr": "Vous avez vaincu un nouveau boss: les Poires-Melbombes !",
      "en": "You killed a new monster: the Baddybombs Pears!",
      "es": "Has matado un nuevo monstruo: ¡las Peras Malabombas!"
    },
    "require": [
      {
        "id": "1180",
        "qty": 1
      }
    ]
  },
  {
    "id": "39",
    "title": {
      "fr": "Mixeur de Tagadas",
      "en": "Tagadas mixer",
      "es": "Triturador de Tagadas"
    },
    "description": {
      "fr": "Vous n'avez fait qu'une bouchée des Fraises-Tagada !",
      "en": "You have only had a Tagada-Strawberry mouthful!",
      "es": "Receta de Batido de fresa: azúcar, leche, un huevo y un buen montón de Fresas Tagada. Poner nata al final para decorar."
    },
    "require": [
      {
        "id": "1181",
        "qty": 1
      }
    ]
  },
  {
    "id": "40",
    "title": {
      "fr": "Kiwi frotte s'y pique",
      "en": "Kiwi itches! ouch, it scratches!",
      "es": "Kiwi rasca, vaya cómo pica..."
    },
    "description": {
      "fr": "Vous avez su éviter tous les pièges des Sapeur-kiwis !",
      "en": "You knew how to avoid all the traps from the Kiwi Sappers!",
      "es": "¡Conseguiste evitar todas las trampas de los Kiwis Zapadores!"
    },
    "require": [
      {
        "id": "1182",
        "qty": 1
      }
    ]
  },
  {
    "id": "41",
    "title": {
      "fr": "Chasseur de Bondissantes",
      "en": "Leaping Hunter",
      "es": "Cazador de Sandinas"
    },
    "description": {
      "fr": "Vous ne vous êtes pas laissé impressionner par la meute de Bondissantes !",
      "en": "Great, you haven't been impressed by the herd of Leapers!",
      "es": "Estupendo, ¡no te has dejado impresionar por la manada de Sandinas!"
    },
    "require": [
      {
        "id": "1183",
        "qty": 1
      }
    ]
  },
  {
    "id": "42",
    "title": {
      "fr": "Tronçonneur d'Ananargeddons",
      "en": "Armaggedon-Pineapple Killer",
      "es": "Aniquilador de Piñaguedones"
    },
    "description": {
      "fr": "Vous êtes venu à bout d'un groupe d'Ananargeddons surentraînés !",
      "en": "You have gloriously come to the end of the fight against the Armageddon-Pineapples!",
      "es": "¡Llegaste gloriosamente hasta el final en la lucha contra los Piñaguedones!"
    },
    "require": [
      {
        "id": "1184",
        "qty": 1
      }
    ]
  },
  {
    "id": "43",
    "title": {
      "fr": "Roi de Hammerfest",
      "en": "Hammerfest King",
      "es": "Rey de Hammerfest"
    },
    "description": {
      "fr": "Votre persévérance et votre ténacité ont eu raison du sorcier Tuberculoz: vous avez retrouvé la carotte de Igor ! Vous débuterez vos prochaines parties avec une vie supplémentaire et Igor portera fièrement sa carotte préférée.",
      "en": "You finished the game! Your perseverance and tenacity permitted you to defeat the evil Tuber and to recover Igor's nose. From now on you'll have an extra life and you'll play with the carrot!",
      "es": "¡Te has pasado el juego! Tu perseverancia y tu tenacidad te permitieron derrotar al malvado Tubérculo y recuperar la nariz de Igor. ¡A partir de ahora jugarás siempre con una vida extra y la zanahoria!"
    },
    "require": [
      {
        "id": "102",
        "qty": 1
      }
    ]
  },
  {
    "id": "44",
    "title": {
      "fr": "Chapelier fou",
      "en": "Mad hatter",
      "es": "Sombrero loco"
    },
    "description": {
      "fr": "Igor s'est découvert une passion nouvelle pour les coiffes. Vous pourrez maintenant appuyer sur la touche \"D\" pendant la partie pour changer de déguisement !",
      "en": "Igor has discovered a mad passion for hats. From now on, disguise Igor by pressing \"D\" key.",
      "es": "Igor ha descubierto una nueva pasión por los gorros. Podrás a partir de ahora darle a la tecla \"D\" durante la partida para cambiar de disfraz."
    },
    "require": [
      {
        "id": "72",
        "qty": 5
      },
      {
        "id": "91",
        "qty": 5
      },
      {
        "id": "92",
        "qty": 10
      }
    ]
  },
  {
    "id": "45",
    "title": {
      "fr": "Poney éco-terroriste",
      "en": "Eco-terrorist pony",
      "es": "Poni eco-terrorista"
    },
    "description": {
      "fr": "Igor a accumulé suffisament de richesses pour financer ses activités louches en Hammerfest. Il peut maintenant se déguiser en appuyant sur la touche \"D\" pendant la partie ! Et sinon, si ca n'est pas déjà fait, avez-vous déjà visité www.dinoparc.com ?",
      "en": "Igor has accumulated enough wealth to finance his terrorist activities in Hammerfest. From now on, he will be able to disguise himself by pressing \"D\" key during the game! By the way, have you already played www.dinoparc.com?",
      "es": "Igor ha acumulado suficientes riquezas que le permiten financiar sus actividades terroristas en Hammerfest. ¡Ahora puede disfrazarse pulsando a la tecla \"D\" durante la partida! Por cierto, ¿has jugado ya a www.dinoparc.es?"
    },
    "require": [
      {
        "id": "1053",
        "qty": 10
      },
      {
        "id": "1054",
        "qty": 10
      },
      {
        "id": "95",
        "qty": 3
      }
    ]
  },
  {
    "id": "46",
    "title": {
      "fr": "Le Pioupiouz est en toi",
      "en": "The Pioupiou is in you",
      "es": "El Pioupiouz está en ti"
    },
    "description": {
      "fr": "Il fallait s'y attendre: à force de ramasser n'importe quoi, Igor s'est fait gober par un Pioupiou ! Appuyez sur la touche \"D\" pendant la partie pour changer de déguisement (au fait, vous connaissiez le site www.pioupiouz.com ?)",
      "en": "We should have expected that: after collecting no matter what kind of item, Igor has finished by devouring a Pioupiou! Press \"D\" key during the game to change fancy dress.",
      "es": "Había que esperarlo: a base de recoger cualquier cosa, ¡Igor ha acabado devorando un Píopío! Pulsa la tecla \"D\" durante la partida para cambiar de disfraz."
    },
    "require": [
      {
        "id": "112",
        "qty": 1
      }
    ]
  },
  {
    "id": "47",
    "title": {
      "fr": "Chasseur de champignons",
      "en": "Mushrooms hunter",
      "es": "Cazador de champiñones"
    },
    "description": {
      "fr": "Comme son homologue italien (plombier de son état), Igor a une passion bizarre pour les champignons. Il pourra désormais se déguiser en appuyant sur la touche \"D\" pendant la partie !",
      "en": "Like his Italian counterpart (plumber in a red hat), Igor feels a great passion for mushrooms! You'll be able from now on to change Igor's dress during the game by pressing \"D\" key.",
      "es": "Como su homólogo italiano (fontanero con gorra roja), Igor siente una gran pasión por los champiñones. ¡Podrás a partir de ahora disfrazar a Igor pulsando la tecla \"D\" durante la partida!"
    },
    "require": [
      {
        "id": "14",
        "qty": 1
      },
      {
        "id": "15",
        "qty": 1
      },
      {
        "id": "16",
        "qty": 1
      },
      {
        "id": "17",
        "qty": 1
      }
    ]
  },
  {
    "id": "48",
    "title": {
      "fr": "Successeur de Tuberculoz",
      "en": "Tuber's successor",
      "es": "Sucesor de Tubérculo"
    },
    "description": {
      "fr": "Igor semble avoir... changé.. Son regard est maintenant plus froid. Il affiche une mine sombre et se cache maintenant sous une grande cape pourpre. Petit à petit, il devient ce qu'il a combattu... Vous pouvez maintenant revêtir l'apparence du sorcier Tuberculoz en appuyant sur \"D\" pendant la partie !",
      "en": "It seems like Igor has... changed. His look has become cool. He hides behind a great cloak and his face is dark. He's maybe changing little by little into the monster who was once his enemy. Disguise Igor as Tuber by pressing \"D\" key during the game!",
      "es": "Parece que Igor ha... cambiado. Su mirada se ha vuelto fría. Se esconde tras una gran capa marrón y ahora su semblante es oscuro. Parece que poco a poco se está transformando en quien fue su enemigo. ¡Disfrázate de Tubérculo pulsando la tecla \"D\" durante la partida!"
    },
    "require": [
      {
        "id": "113",
        "qty": 1
      }
    ]
  },
  {
    "id": "49",
    "title": {
      "fr": "La première clé !",
      "en": "The first Key!",
      "es": "¡La primera Llave!"
    },
    "description": {
      "fr": "Igor a trouvé une sorte de Passe-partout en Bois. Nul doute qu'il ouvre une porte quelque part dans les cavernes...",
      "en": "Igor has found a Master Key. Undoubtedly, it will open a door somewhere in the caverns...",
      "es": "Igor ha encontrado una Llave Maestra de Madera. Sin duda debe de abrir una puerta en algún sitio de las cavernas..."
    },
    "require": [
      {
        "id": "1190",
        "qty": 1
      }
    ]
  },
  {
    "id": "50",
    "title": {
      "fr": "Rigor Dangerous",
      "en": "Rigor Dangerous",
      "es": "Rigor Dangerous"
    },
    "description": {
      "fr": "Vous avez découvert dans votre aventure une vieille clé rouillée mystérieuse ! Elle comporte une petite mention gravée: \"Rick\". Sans doute son ancien propriétaire...",
      "en": "You have discovered an old Rusty Key in your adventure! It has a small inscription: \"Rick\". Obviously, this was its previous owner.",
      "es": "¡Has descubierto en tu aventura una vieja Llave Oxidada! Contiene una pequeña inscripción: \"Rick\". Sin duda fue su antiguo propietario..."
    },
    "require": [
      {
        "id": "1191",
        "qty": 1
      }
    ]
  },
  {
    "id": "51",
    "title": {
      "fr": "La Méluzzine perdue",
      "en": "The lost Meluzin",
      "es": "La Meluzine perdida"
    },
    "description": {
      "fr": "La Méluzzine, clé légendaire sortie des vieux contes hammerfestiens, ouvre à ce qu'on raconte la porte de grandes richesses. Reste à savoir où ?",
      "en": "They say that the Meluzin, the legendary key of the ancient Hammerfest tales, opens the door to the greatest wealth. But where is the door?",
      "es": "La Meluzine, llave legendaria salida de viejos cuentos hammerfestianos, abre según dicen la puerta a grandes riquezas. Queda por saber dónde está esa puerta..."
    },
    "require": [
      {
        "id": "1192",
        "qty": 1
      }
    ]
  },
  {
    "id": "52",
    "title": {
      "fr": "Enfin le Bourru !",
      "en": "At last, the drunk man!",
      "es": "¡Por fin el borracho!"
    },
    "description": {
      "fr": "Cette étrange petite clé sent le vin.",
      "en": "This strange little key smells of wine: it's the Wine Key!",
      "es": "Esta extraña pequeña llave huele a vino: ¡es la Llave Borracha!"
    },
    "require": [
      {
        "id": "1193",
        "qty": 1
      }
    ]
  },
  {
    "id": "53",
    "title": {
      "fr": "Congélation",
      "en": "Frozen",
      "es": "Congelación"
    },
    "description": {
      "fr": "Bien qu'étant un bonhomme de neige, Igor lui-même a du mal à garder cette clé en main, tant le froid qu'elle dégage est intense. La porte qu'elle ouvre donne sûrement sur les endroits les plus reculés de Hammerfest.",
      "en": "Like any other snowman, Igor can't keep a key like this one in his hand. The door that it opens gives access to the most hidden places of Hammerfest.",
      "es": "Como cualquier otro hombre de nieve, Igor tiene problemas para guardar esta llave en la mano. Esta puerta da acceso a los lugares más recónditos de Hammerfest."
    },
    "require": [
      {
        "id": "1194",
        "qty": 1
      }
    ]
  },
  {
    "id": "54",
    "title": {
      "fr": "Une clé rouillée",
      "en": "A rusty key",
      "es": "Una llave herrumbrosa"
    },
    "description": {
      "fr": "Ce petit bout de ferraille difforme n'a pas l'air d'avoir une grande valeur. Mais il faut parfois ce méfier des apparences ! Qui peut savoir quel genre d'aventure se cache au delà de la porte qu'elle ouvre ?",
      "en": "This amorphous metallic thing does not seem to be worth a lot. Although, we should not trust appearances! Who knows what adventures hide beyond the door it opens?",
      "es": "Este pequeño trozo metálico amorfo no parece tener un gran valor. ¡Sin embargo hay que desconfiar de las apariencias! ¿Quién puede saber qué clase de aventura se esconde más allá de la puerta que abrirá?"
    },
    "require": [
      {
        "id": "1195",
        "qty": 1
      }
    ]
  },
  {
    "id": "55",
    "title": {
      "fr": "Laissez passer !",
      "en": "Let it go!",
      "es": "¡Dejadlo libre!"
    },
    "description": {
      "fr": "Votre toute puissance administrative sera dorénavant appuyée par le formulaire d'Autorisation du Bois-Joli BJ22a.",
      "en": "All your administrative power will be backed up by the LovelyWood BJ22a Authorization Form.",
      "es": "Todo tu poder administrativo contará con el apoyo del formulario de Autorización Madera-Bonita BJ22a."
    },
    "require": [
      {
        "id": "1196",
        "qty": 1
      }
    ]
  },
  {
    "id": "56",
    "title": {
      "fr": "Les mondes ardus",
      "en": "The Arduous Worlds",
      "es": "Los Mundos Arduos"
    },
    "description": {
      "fr": "Pour avoir atteint le niveau 50 en mode Cauchemar, vous avez gagné la Clé des Mondes Ardus.",
      "en": "You achieved level 50 in the Nightmare mode! You win the Arduous Worlds Key!",
      "es": "Debido a que has alcanzado el nivel 50 en el modo Pesadilla, ¡ganas la Llave de los Mundos Arduos!"
    },
    "require": [
      {
        "id": "1197",
        "qty": 1
      }
    ]
  },
  {
    "id": "57",
    "title": {
      "fr": "Viiiite !",
      "en": "Quickly!",
      "es": "¡Ráaapido!"
    },
    "description": {
      "fr": "Sans trop savoir pourquoi, la Clé Piquante que vous avez trouvé vous donne une folle envie de courir partout et de vous rouler en boule.",
      "en": "You don't really know why, but the Itchy Key you've found, makes you run and roll everywhere!",
      "es": "Sin saber muy bien por qué, la Llave Que Rasca que has encontrado te da unas ganas tremendas de correr por todos lados y rodar como un ovillo."
    },
    "require": [
      {
        "id": "1198",
        "qty": 1
      }
    ]
  },
  {
    "id": "58",
    "title": {
      "fr": "Faire les poches à Tubz",
      "en": "Empty Tuber's pocket",
      "es": "Vacíarle los bolsillos a Tubérculo"
    },
    "description": {
      "fr": "Tuberculoz, le vilain sorcier, portait sur lui une clé...",
      "en": "Tuber, the evil sorcerer, used to have a key...",
      "es": "Tubérculo, el hechicero malvado, llevaba una llave..."
    },
    "require": [
      {
        "id": "1199",
        "qty": 1
      }
    ]
  },
  {
    "id": "59",
    "title": {
      "fr": "Tuberculoz, seigneur des enfers",
      "en": "Tuber, Master of Hell",
      "es": "Tubérculo, señor de los infiernos"
    },
    "description": {
      "fr": "Votre toute puissance et votre maîtrise absolue des techniques de combat de Hammerfest vous ont permi de gagner une clé unique en terrassant Tuberculoz en mode Cauchemar !",
      "en": "All your great power and skill in combat techniques gave you the chance to defeat Tuber in the Nightmare mode! You're now the privileged owner of the Unique Key.",
      "es": "¡Todo tu poder y maestría absoluta de las técnicas de combate de Hammerfest permitieron que derrotaras al mismísimo Tubérculo en el modo Pesadilla! Gracias a ello eres el privilegiado poseedor de la Llave Única."
    },
    "require": [
      {
        "id": "1200",
        "qty": 1
      }
    ]
  },
  {
    "id": "60",
    "title": {
      "fr": "L'eau ferrigineuneuse",
      "en": "Metallic water",
      "es": "El agua que sabe a perfume"
    },
    "description": {
      "fr": "Votre excès dans la consommation de boissons alcoolisées vous a permis de débloquer la Clé du Bourru ! Vous aurez maintenant de bonnes chances de la trouver au cours de vos explorations.",
      "en": "Alcohol abuse is bad for your health, according to the health authorities. However, in Hammerfest it has enabled you to unblock the Wine Key! From now on, you have a lot of chances of finding it in the caverns.",
      "es": "El exceso del consumo de alcohol es perjudicial para la salud. Lo dicen las autoridades sanitarias. Sin embargo, ¡en Hammerfest te ha permitido desbloquear la Llave Borracha! A partir de ahora tienes muchas posibilidades de encontrarla en las cavernas."
    },
    "require": [
      {
        "id": "1209",
        "qty": 20
      },
      {
        "id": "1210",
        "qty": 10
      },
      {
        "id": "1211",
        "qty": 5
      },
      {
        "id": "1212",
        "qty": 3
      },
      {
        "id": "1213",
        "qty": 2
      }
    ]
  },
  {
    "id": "61",
    "title": {
      "fr": "Paperasse administrative",
      "en": "Paperwork",
      "es": "Papeleo"
    },
    "description": {
      "fr": "Igor est un maître dans l'art de remplir des formulaires administratifs. Il trouvera donc sans problème bientôt l'Autorisation du Bois-Joli dans les dédales des cavernes...",
      "en": "Igor is an expert in filling in administrative forms. You'll soon find the LovelyWood BJ22a Authorization Form in the caverns.",
      "es": "Igor es un maestro en el arte de rellenar formularios administrativos. Pronto podrás encontrar la Autorización Madera-bonita BJ22a en las cavernas."
    },
    "require": [
      {
        "id": "1214",
        "qty": 10
      },
      {
        "id": "1215",
        "qty": 15
      },
      {
        "id": "1216",
        "qty": 3
      },
      {
        "id": "1217",
        "qty": 2
      },
      {
        "id": "1218",
        "qty": 1
      }
    ]
  },
  {
    "id": "62",
    "title": {
      "fr": "Meilleur joueur",
      "en": "Best Player",
      "es": "Mejor jugador"
    },
    "description": {
      "fr": "Le meilleur joueur du net, c'est vous, plus personne n'a de doute là dessus ! Votre collection de manettes de jeu fera sans nul doute des envieux ^^ Igor dispose maintenant de l'option Tornade qui procure un boost de vitesse au début de chaque partie, quelques soient les options choisies !",
      "en": "The best videogame player is you, there's no doubt about it! Your control pads collection is enviable! From now on, Igor has a speed bonus at the beginning of each game.",
      "es": "El mejor jugador de videojuegos eres tú, ¡sin ninguna duda! ¡Tu colección de mandos de consola es envidiable! A partir de ahora Igor posee desde el principio de cada partida un bonus en rapidez."
    },
    "require": [
      {
        "id": "1201",
        "qty": 1
      },
      {
        "id": "1202",
        "qty": 1
      },
      {
        "id": "1203",
        "qty": 1
      },
      {
        "id": "1204",
        "qty": 1
      },
      {
        "id": "1205",
        "qty": 1
      },
      {
        "id": "1206",
        "qty": 1
      },
      {
        "id": "1207",
        "qty": 1
      },
      {
        "id": "1208",
        "qty": 1
      }
    ]
  },
  {
    "id": "63",
    "title": {
      "fr": "Miroir, mon beau miroir",
      "en": "Mirror, my beautiful mirror",
      "es": "Espejo, mi bonito espejo"
    },
    "description": {
      "fr": "Le Miroir Bancal que vous avez trouvé en jeu vous permet maintenant de voir les choses sous un angle nouveau. L'option de jeu \"Miroir\" a été débloquée !",
      "en": "The Bancal Mirror you have found in the game shows you things from another point of view. The extra option \"Mirror\" has been unblocked!",
      "es": "El Espejo Bancal que has encontrado en el juego te permite ahora ver las cosas desde un ángulo diferente. ¡La opción suplementaria de juego \"Espejo\" ha sido desbloqueada!"
    },
    "require": [
      {
        "id": "1219",
        "qty": 1
      }
    ]
  },
  {
    "id": "64",
    "title": {
      "fr": "Mode cauchemar",
      "en": "Nightmare mode",
      "es": "Modo pesadilla"
    },
    "description": {
      "fr": "Vous êtes doué. Surement très doué même... Mais saurez-vous aider Igor en mode Cauchemar ? Cette option a été débloquée !",
      "en": "You're talented. Very talented... but, are you able to help Igor in the Nightmare mode? This new option has been unblocked!",
      "es": "Tienes talento. Mucho talento... pero ¿serías capaz de ayudar a Igor en el modo Pesadilla? ¡Esta opción ha sido desbloqueada!"
    },
    "require": [
      {
        "id": "1220",
        "qty": 1
      }
    ]
  },
  {
    "id": "65",
    "title": {
      "fr": "L'aventure continue !",
      "en": "The adventure continues!",
      "es": "¡La aventura continúa!"
    },
    "description": {
      "fr": "Le conseil des Carotteux vous a choisi pour explorer plus en avant les cavernes de Hammerfest. La Clé de Gordon est une première étape dans cette nouvelle mission.",
      "en": "The Carrotian Council has chosen you to explore the Caverns of Hammerfest in-depth. The Gordon's Key is only the first step of a new great mission...",
      "es": "El consejo de los Zanahorios y Panteonianos te ha elegido para explorar con más atención las Cavernas de Hammerfest. La Llave de Gordon es tan sólo la primera etapa de una nueva misión."
    },
    "require": [
      {
        "id": "117",
        "qty": 1
      }
    ]
  },
  {
    "id": "66",
    "title": {
      "fr": "Joyau d'Ankhel",
      "en": "Ankhel Jewel",
      "es": "Joya de Ankhel"
    },
    "description": {
      "fr": "Vous avez fait preuve d'une dextérité et d'une perspicacité sans égal en retrouvant le Joyau d'Ankhel. L'option Controle du Ballon a été débloquée pour le mode SoccerFest !",
      "en": "You have shown your great ability and dexterity in finding the Ankhel Jewel. The Advanced Ball Control option has been unblocked in the Soccerfest mode game!",
      "es": "Has hecho prueba de una habilidad y perspicacia sin igual al encontrar la Joya de Ankhel. ¡La opción Control Avanzado del Balón ha sido desbloqueada en el modo Fútbolfest!"
    },
    "require": [
      {
        "id": "116",
        "qty": 1
      }
    ]
  },
  {
    "id": "67",
    "title": {
      "fr": "Sandy commence l'aventure !",
      "en": "Sandy's adventure begins!",
      "es": "¡Sandy comienza la aventura!"
    },
    "description": {
      "fr": "Tous les éléments sont réunis pour donner naissance à Sandy, le bonhomme de sable ! Ce nouveau personnage pourra se joindre à vous dans le mode Multi Coopératif, jouable à deux sur le même ordinateur. Re-découvrez la grande aventure avec un ami !",
      "en": "You’ve got all the necessary elements to bring Sandy the Sandman to life! This new character can join you in the Adventure Mode (Two players mode on the same computer).",
      "es": "¡Todos los elementos han sido reunidos para en fin dar vida a Sandy, el hombre de arena! Este nuevo personaje podrá unirse a ti en el modo Cooperativo, disponible para dos jugadores en el mismo ordenador. ¡Re-descubre la gran aventura con un amigo!"
    },
    "require": [
      {
        "id": "1221",
        "qty": 5
      },
      {
        "id": "1222",
        "qty": 10
      },
      {
        "id": "1223",
        "qty": 5
      },
      {
        "id": "1224",
        "qty": 3
      }
    ]
  },
  {
    "id": "68",
    "title": {
      "fr": "Miroir, NOTRE beau miroir",
      "en": "Mirror, OUR beautiful mirror",
      "es": "Espejo, NUESTRO bonito espejo"
    },
    "description": {
      "fr": "Avec le Miroir des Sables, vous pouvez maintenant voir les choses sous un angle nouveau mais à deux ! L'option de jeu \"Miroir\" a été débloquée pour le mode Multi Coopératif !",
      "en": "You can now see things from a different angle with your friend. The game option \"Mirror\" has been added to the Two Players game mode.",
      "es": "Con el Espejo de las Arenas, puedes ver la cosas desde nuevo ángulo... ¡y con un amigo! La opción de juego \"Espejo\" ha sido desbloqueada para el modo Cooperativo."
    },
    "require": [
      {
        "id": "1225",
        "qty": 1
      }
    ]
  },
  {
    "id": "69",
    "title": {
      "fr": "Mode double cauchemar",
      "en": "Double-nightmare option",
      "es": "Modo Doble Pesadilla"
    },
    "description": {
      "fr": "De toute évidence, vous êtes capables de grandes choses à deux ! L'option de jeu \"Cauchemar\" a été débloquée pour le mode Multi Coopératif !",
      "en": "It is evident that you are able to do great things together with a friend! The game option \"Nightmare\" has been added to the Two Players game mode.",
      "es": "¡Está claro que eres capaz de llegar lejos cuando estás acompañado! La opción de juego \"Pesadilla\" ha sido desbloqueada para el modo Cooperativoooooo."
    },
    "require": [
      {
        "id": "1226",
        "qty": 1
      }
    ]
  },
  {
    "id": "70",
    "title": {
      "fr": "Une grande Amitié",
      "en": "A great Friendship",
      "es": "Una gran Amistad"
    },
    "description": {
      "fr": "Mieux vaut tard que jamais ! Igor et Sandy ont enfin compris qu'il valait mieux s'entraider s'ils voulaient survivre à deux dans les Cavernes de Hammerfest. L'option de jeu \"Partage de vies\" a été débloquée pour le mode Multi Coopératif ! Si cette option est activée, lorsqu'un joueur perd sa dernière vie, il en prend une au second joueur et peut ainsi continuer la partie !",
      "en": "Better late than never! Igor and Sandy have finally understood the importance of staying together in order to survive in the Caverns. The game option \"Lives sharing\" has been unblocked for the Two Players mode! With this option enabled, if a player loses his latest life, he will take a life from the second player and then he will be able to continue playing!",
      "es": "¡Más vale tarde que nunca! Igor y Sandy han comprendido que es mejor trabajar juntos para sobrevivir en las Cavernas. La opción de juego \"Compartir vidas\" ha sido desbloqueada para el modo Cooperativo. Si esta opción es activada, cuando un jugador pierde su última vida, utiliza una del segundo jugador para poder continuar la partida."
    },
    "require": [
      {
        "id": "1227",
        "qty": 2
      }
    ]
  },
  {
    "id": "71",
    "title": {
      "fr": "Apprentissage des canifs volants",
      "en": "Learning how to launch Shurikens",
      "es": "Aprendizaje de lanzamiento shurikens"
    },
    "description": {
      "fr": "A toujours sauter partout, Igor a fini par acquérir une souplesse digne d'un ninja et une dextérité hors du commun ! Mais pour prouver sa valeur, il doit maintenant collecter les artefacts ninjas dispersés en Hammerfest !",
      "en": "Jumping and jumping around has improved Igor's agility and now he's turning into a ninja! In order to prove his courage, he must collect all the ninja items hidden in Hammerfest!",
      "es": "De tanto saltar Igor ha desarrollado una habilidad digna de un gran ninja... Para probar su talento, deberá recoger artefactos ninja dispersados en las cavernas."
    },
    "require": [
      {
        "id": "1228",
        "qty": 1
      }
    ]
  },
  {
    "id": "72",
    "title": {
      "fr": "Shinobi do !",
      "en": "Shinobi do!",
      "es": "¡Shinobi do!"
    },
    "description": {
      "fr": "Igor a rempli sa quêté initiatique et maîtrise maintenant à la perfection un grand nombre d'armes du Ninjutsu ! Mais comme son nouveau de l'honneur le lui interdit, il ne pourra pas s'en servir. Toutefois, il pourra mettre à l'épreuve ses compétences grâce à l'option de jeu \"Ninjutsu\" qu'il vient de débloquer pour le mode Aventure !",
      "en": "Igor has completed his starting quest and now he's a grand master of Ninjutsu weapons! Nevertheless, his Code of Honour prevents him from using them. Although now he will be able to test his skills in the \"Ninjutsu\" game mode he has unblocked!",
      "es": "¡Igor ha terminado la exploración de iniciación en la vía del Ninjutsu! Gracias a ello la opción de juego \"Ninjutsu\" ha sido desbloqueada para el modo Aventura."
    },
    "require": [
      {
        "id": "1229",
        "qty": 5
      },
      {
        "id": "1230",
        "qty": 2
      },
      {
        "id": "1231",
        "qty": 7
      },
      {
        "id": "1232",
        "qty": 7
      },
      {
        "id": "1233",
        "qty": 1
      },
      {
        "id": "1234",
        "qty": 1
      },
      {
        "id": "1235",
        "qty": 1
      }
    ]
  },
  {
    "id": "73",
    "title": {
      "fr": "Rapide comme l'éclair !",
      "en": "As quick as the lightning!",
      "es": "Rápido como el rayo..."
    },
    "description": {
      "fr": "Igor est imbattable dès lors qu'il s'agit de viser juste et se déplacer avec précision... Il faut maintenant le prouver aux autres ! Le mode TIME ATTACK est débloqué et vous ouvre en plus l'accès à un nouveau classement sur le site. Soyez le bonhomme de neige le plus rapide de tout Hammerfest !",
      "en": "Igor is unbeatable when he needs to move fast. He now has to prove it to the others! The TIME ATTACK mode and its ranking have been unblocked. Be the fastest snowman in all Hammerfest!",
      "es": "Igor es imbatible para apuntar y lanzar con precisión... ¡Ahora hay que probárselo a todo el mundo! El modo CONTRARRELOJ ha sido desbloqueado y te ofrece la posibilidad de acceder a la nueva clasificación CONTRARRELOJ. ¡Ya puedes ser el muñeco de nieve más rápido de Hammerfest!"
    },
    "require": [
      {
        "id": "1236",
        "qty": 100
      }
    ]
  },
  {
    "id": "74",
    "title": {
      "fr": "Maître des Bombes",
      "en": "Bomb Master",
      "es": "Maestro de Bombas"
    },
    "description": {
      "fr": "Vous êtes l'expert réputé dans tout Hammerfest en matière d'explosifs. Et pour montrer qu'on ne vous ne la fait pas, à vous, l'option \"Explosifs instables\" a été débloquée pour le mode Aventure ! Gare à TOUT ce qui explose en jeu ! De plus, vous pouvez pousser toutes vos bombes plus loin en avançant en même temps que vous la frappez.",
      "en": "You are a well-known expert in explosive material. To demonstrate this to everybody, you can now enable the \"Unstable explosives\" option in the Adventure mode. Pay attention to everything that explodes in the game! You can also push the bombs farther and move while you hit them.",
      "es": "Eres el mayor experto en materia explosiva de la región de Hammerfest. La opción \"Explosivos inestables\" ha sido desbloqueada para el modo Aventura. Además, también podrás empujar las bombas más lejos al mismo tiempo que avanzas y golpeas."
    },
    "require": [
      {
        "id": "1237",
        "qty": 1
      }
    ]
  },
  {
    "id": "75",
    "title": {
      "fr": "Tombeau de Tuberculoz",
      "en": "Tuber's tomb",
      "es": "Tumba de Tubérculo"
    },
    "description": {
      "fr": "Vous avez découvert une étrange pyramide de poche dans le tombeau de Tuberculoz.",
      "en": "You have discovered a bizarre pocket-size pyramid in Tuber's tomb.",
      "es": "Has descubierto una extraña pirámide de bolsillo en la tumba de Tubérculo."
    },
    "require": [
      {
        "id": "1238",
        "qty": 1
      }
    ]
  },


  {
    "//": "Custom quest for Hammerfest Deluxe",
    "id": "100",
    "title": {
      "fr": "Une carotte de luxe",
      "en": "A deluxe carrot",
      "es": "Una zanahoria deluxe"
    },
    "description": {
      "fr": "Les Éternels ont pu utiliser la magie de cette carotte pour débloquer encore plus de possibilités ! De nouveaux modes, options et niveaux secrets sont apparus un peu partout !",
      "en": "The Eternals were able to use the magic of this carrot to unlock even more possibilities! New modes, options and secret levels have appeared everywhere!",
      "es": "¡Los Eternos han podido utilizar la magia de esta zanahoria para desbloquear aún más posibilidades! ¡Nuevos modos, opciones y niveles secretos han aparecido por doquier!"
    },
    "require": [
      {
        "id": "102",
        "qty": 1
      }
    ]
  },
  {
    "//": "Custom quest for Hammerfest Deluxe",
    "id": "101",
    "title": {
      "fr": "Couronné de succès",
      "en": "Crowned with success",
      "es": "Coronado des éxitos"
    },
    "description": {
      "fr": "Ça aura pris 17 ans, mais vous réussissez enfin à faire entrer ces objets légendaires dans votre frigo ! De nouveaux déguisements sont disponibles avec la touche \"D\" en mode Deluxe !",
      "en": "It has taken 17 years, but you've finally managed to get these legendary items into your fridge! New disguises are available by pressing \"D\" in Deluxe mode!",
      "es": "Has tardado 17 años, ¡pero por fin has conseguido meter estos objetos legendarios en tu nevera! ¡Nuevos disfraces disponibles pulsando \"D\" en el modo Deluxe!"
    },
    "require": [
      {
        "id": "115",
        "qty": 1
      },
      {
        "id": "1186",
        "qty": 1
      },
      {
        "id": "1187",
        "qty": 1
      },
      {
        "id": "1188",
        "qty": 1
      },
      {
        "id": "1189",
        "qty": 1
      }
    ]
  }
]
